import App from './App.vue'
import { createApp } from 'vue'

export const app = createApp(App)
